// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gRVR","buttons":"styles_buttons__3lJ4K"};